import { Component } from '@angular/core';


/**
 * Generated class for the HyperLinkComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'hyper-link',
  templateUrl: 'hyper-link.html'
})
export class HyperLinkComponent{

  gridLink: string;

  constructor() {
  }
  agInit(params: any): void {
    console.log("ak")
    this.gridLink = params
  }
}



// WEBPACK FOOTER //
// ./src/components/hyper-link/hyper-link.ts